import { PaymentChannelModel } from 'api-hooks/payment-channel';
import * as Yup from 'yup';

export const PaymentChannelFormSchema = () =>
  Yup.object({
    name: Yup.string().default('').required(),
    description: Yup.string().default(''),
    isActive: Yup.boolean().default(false),
  });

export type PaymentChannelFormType = {
  name: string;
  description: string;
  isActive: boolean;
  paymentChannel?: PaymentChannelModel;
};
